export default __webpack_public_path__ + "assets/images/12.2e08e3.png";